function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useMemo } from 'react';
import theme from '@adsk/alloy-react-theme';
const SKELETON_GRADIENT_PROPS = [{
  foregroundColor: theme.tokens.colors.skeleton.shimmer.five.value,
  backgroundColor: theme.tokens.colors.skeleton.shimmer.four.value
}, {
  foregroundColor: theme.tokens.colors.skeleton.shimmer.four.value,
  backgroundColor: theme.tokens.colors.skeleton.shimmer.three.value
}, {
  foregroundColor: theme.tokens.colors.skeleton.shimmer.three.value,
  backgroundColor: theme.tokens.colors.skeleton.shimmer.two.value
}, {
  foregroundColor: theme.tokens.colors.skeleton.shimmer.two.value,
  backgroundColor: theme.tokens.colors.skeleton.shimmer.one.value
}];
export default (_ref => {
  let {
    table,
    tableSize,
    numberOfRows = 8,
    columnIdsToRemove = ['actions']
  } = _ref;
  const getSkeletonLoadingRows = useCallback(() => Array.from({
    length: numberOfRows
  }).map((_, index) => ({
    id: "skeleton-row-".concat(index),
    index
  })), [numberOfRows]);
  const tableCells = useMemo(() => table.getAllLeafColumns().filter(c => !columnIdsToRemove.includes(c.id)).map(column => ({
    columnId: column.id,
    tableSize,
    size: column.getSize(),
    isResizing: column.getIsResizing()
  })), [table, columnIdsToRemove, tableSize]);
  const getSkeletonLoadingRowProps = useCallback(row => _objectSpread(_objectSpread(_objectSpread({}, row), SKELETON_GRADIENT_PROPS[Math.min(row.index, SKELETON_GRADIENT_PROPS.length - 1)]), {}, {
    tableSize,
    tableCells
  }), [tableCells, tableSize]);
  return {
    getSkeletonLoadingRows,
    getSkeletonLoadingRowProps
  };
});
//# sourceMappingURL=useSkeletonLoadingRows.js.map